<template>
  <v-card class="card local-table">
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="searchPlaceholder"
          hide-details
          outlined
          dense
          class="poisSearch"
      ></v-text-field>

      <v-autocomplete
        :label="$t('type')"
        :items="poiTypes"
        item-text="name"
        item-value="id"
        v-model="selectedPoiType"
        hide-details="auto"
        dense
        outlined
        class="poisSearch"
        v-if="!isUserDriverRole"
        @change="changePoiType">
      </v-autocomplete>

    <v-data-table
          :fixed-header="true"
          class="text-caption"
          width="100%"
          dense
          :footer-props="{ 'items-per-page-text': $t('perPage'), 'items-per-page-options': [20, 50, 100] }"
          :headers="headers"
          :height="tableHeight"
          :items="poisForTable"
          :server-items-length="totalPois"
          :loading="loading"
          mobile-breakpoint
          :options.sync="options"
          :search="search"
        >
        <template v-slot:body="{ items }">
          <tbody>
            <template v-for="(item, index) in items">
              <tr :key="index">
                <td><a @click="clickOnPoiName(item)">{{ item.name }}</a></td>
                <td><span v-if="item.radius != null">{{ item.radius }}</span></td>
                <td>
                  <v-row justify="space-around">
                    <v-btn icon x-small @click="editPoi(item)">
                      <v-icon color="orange">edit</v-icon>
                    </v-btn>
                    <v-btn icon x-small @click="deletePoiQuestion(item)">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </v-row>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-data-table>

      <ImportBtn v-if="excelImportData" :bulkProps="excelImportData" v-useCase="excelImportData.useCase"/>

      <v-dialog v-model="dialog" width="260">
        <v-card>
          <v-card-title class="headline">
            <span class="deleteDialogTitle">{{ deletePoiTitle }}</span>
          </v-card-title>
          <v-card-actions class="dialogButtons">
            <v-btn color="black darken-1" text @click="deletePoi()">Yes</v-btn>
            <v-btn color="black darken-1" text @click="dialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </v-card>

</template>

<script>
import { mapState } from 'vuex'
import { remove } from '../../../api/map.api'
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import EventBus from '../../../event-bus'
import ImportBtn from '../../tables/BulkImportButton'
import httpClient from '@/api/httpClient'
import { getPoisPaginated } from '../../../api/poi.api'

export default {
  components: {
    ImportBtn
  },
  async mounted() {
    await this.loadPoiTypes()
    if (this.isUserDriverRole && this.poiTypes[2]) {
      this.selectedPoiType = this.poiTypes[2].id
    }
    await this.loadTableData(1)
    this.tableInitialized = true
  },
  computed: {
    ...mapState('user', ['isUserDriverRole']),
    tableHeight: function() {
      return this.totalPois > 14 ? '65vh' : null
    },
    deleteButtonLocalization() {
      return translate('Delete', 'fields')
    },
    searchPlaceholder() {
      return translate('Search', 'realtimeMap')
    },
    deletePoiTitle() {
      return translate('Do you want to delete this item ?', 'notification')
    }
  },
  data() {
    return {
      search: '',
      selectedPoiType: null,
      poisForTable: [],
      totalPois: 0,
      loading: false,
      tableInitialized: false,
      options: {
        page: 1,
        itemsPerPage: 20
      },
      headers: [
        {
          text: translate('Name', 'tables'),
          value: 'name',
          width: 45
        },
        {
          text: translate('Radius', 'fields'),
          value: 'radius',
          width: 45
        },
        {
          text: '',
          width: 5
        }
      ],
      dialog: false,
      poiForRemove: null,
      excelImportData: {
        endpoint:"BulkImport/Pois",
        queryString:"",
        detailComponent:"PoisDetail",
        maxWidth:"600",
        title:"Uvezite podatke za Tačke od interesa",
        href:"#",
        useCase: "PoisBulkImportUseCase",
        needToReloadPage: true
      },
      poiTypes: []
    }
  },
  methods: {
    async loadPoiTypes() {
      await httpClient.get('/lookup/poiTypes')
        .then(response => {
          response.data.unshift({
            name: this.$t('choose'),
            id: null
          })

          this.poiTypes = response.data
      })
    },
    clickOnPoiName(poi) {
      EventBus.$emit('POI_NAME_IN_TABLE_EVENT', poi)
    },
    deletePoiQuestion(poi) {
      this.poiForRemove = poi
      this.dialog = true
    },
    async loadTableData(page) {
      this.loading = true
      try {
        const response = await getPoisPaginated(page, this.options.itemsPerPage, this.selectedPoiType)
        this.poisForTable = response.data.items
        this.totalPois = response.data.totalCount
      } finally {
        this.loading = false
      }
    },
    deletePoi() {
      this.dialog = false
      if (this.poiForRemove) {
        store.dispatch('map/clearOnePoi', this.poiForRemove)
        remove(`/pois/${this.poiForRemove.id}`)
        this.poisForTable = this.poisForTable.filter(x => x.id != this.poiForRemove.id)
        this.totalPois--
      }
    },
    editPoi(data) {
      EventBus.$emit('EDIT_POI_BUTTON_EVENT', data)
    },
    changePoiType() {
      this.loadTableData(1)
    }
  },
  watch: {
    options: {
      handler(val) {
        if (!this.tableInitialized) return
        this.loadTableData(val.page)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.poisSearch {
  margin-bottom: 10px;
}
.card {
  padding: 10px;
  padding-top: 0px;
}
.deleteDialogTitle {
  font-size: 14px !important;
  text-align: center !important;
}
.dialogButtons {
  display: flex;
  justify-content: center;
}
</style>
